import DisplayEstatus from './DisplayEstatus';
export default DisplayEstatus;
